import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { TermsPrivacyDialogComponent } from '@shared/components/terms/terms-privacy-dialog/terms-privacy-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'taxtank-core/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FooterComponent {
  public dialog = inject(MatDialog);
  private authentificationService = inject(AuthService);

  @Input() isWithLogout = false;
  // current year to show it in copyright section
  currentYear = new Date().getFullYear();

  

  openTermsPrivacyDialog(): void {
    const dialogRef = this.dialog.open(TermsPrivacyDialogComponent);
  }

  logout(): void {
    this.authentificationService.logoutFront();
  }
}
